import _toConsumableArray from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";

var getRangeMap = function getRangeMap(dygraph, ranges) {
  return dygraph.getOption('labels').slice(1).reduce(function (a, l, i) {
    var min = +ranges[i][0];
    var max = +ranges[i][1];
    var normalizeRatio = 100 / (max - min);
    var formatRatio = (max - min) / 100;
    return Object.assign(_defineProperty({}, l, {
      normalize: function normalize(y) {
        return (y - min) * normalizeRatio;
      },
      formatValue: function formatValue(y) {
        return y * formatRatio + min;
      }
    }), a);
  }, {});
};

var Normalize = function Normalize(options) {
  _classCallCheck(this, Normalize);

  _initialiseProps.call(this);

  this.updateOptions(options);
};

export { Normalize as default };

Normalize.toString = function () {
  return 'Normalize Plugin';
};

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.updateOptions = function (options) {
    if (typeof options !== 'object' || options.ranges === undefined) {
      throw new Error('Normalize ranges must be provided');
    }

    _this.notches = options.notches ? options.notches : 4;
    _this.ranges = options.ranges;

    if (_this.dygraph) {
      _this.updateRangeMap();
    }
  };

  this.updateRangeMap = function () {
    _this.rangeMap = getRangeMap(_this.dygraph, _this.ranges);
  };

  this.activate = function (dygraph) {
    _this.dygraph = dygraph;

    _this.updateRangeMap();

    var $this = _this;

    var seriesToPoints = function seriesToPoints(series, setName, boundaryIdStart) {
      var points = [];

      for (var i = 0; i < series.length; ++i) {
        points.push({
          x: NaN,
          y: NaN,
          xval: series[i][0] === null ? null : series[i][0],
          yval: series[i][1] === null ? null : $this.rangeMap[setName].normalize(series[i][1]),
          name: setName,
          // TODO(danvk): is this really necessary?
          idx: i + boundaryIdStart,
          canvasx: NaN,
          canvasy: NaN
        });
      }

      this.onPointsCreated_(series, points);
      return points;
    };

    var axes = dygraph.getOption('axes');
    var originalHighlightCabllack = dygraph.getFunctionOption('highlightCallback');
    var highlightCallback;

    if (originalHighlightCabllack) {
      highlightCallback = function highlightCallback(event, x, points, row, seriesName) {
        originalHighlightCabllack.call(dygraph, event, x, points.map(function (point) {
          return Object.assign({}, point, {
            yval: $this.rangeMap[point.name].formatValue(point.yval)
          });
        }), row, seriesName);
      };
    }

    axes.y.valueFormatter = function (y, opts, seriesName) {
      return $this.rangeMap[seriesName].formatValue(y);
    };

    axes.y.ticker = function () {
      return _toConsumableArray(Array(_this.notches + 1).keys()).map(function (n) {
        var value = n / _this.notches * 100;
        return {
          v: value,
          label: value
        };
      });
    };

    dygraph.updateOptions({
      axes: axes,
      valueRange: [0, 100]
    }, true);

    var predraw = function predraw(e) {
      if (highlightCallback) {
        e.dygraph.attributes_.user_.highlightCallback = highlightCallback;
      }

      e.dygraph.dataHandler_.seriesToPoints = seriesToPoints.bind(e.dygraph.dataHandler_);
    };

    return {
      predraw: predraw
    };
  };
};